import {Injectable} from '@angular/core';
import {ApiService} from "../services/api.service";

declare var cookieconsent: any;

@Injectable({
  providedIn: 'root'
})

export class CookieConsentHelper {
  constructor(
    private apiService: ApiService,) {
  }

  getCookie(name: string): string {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(';').shift() || '';
    return '';
  }

  getCookieConsentToken(): string {
    //cookie_consent_user_consent_token
    const cookieConsentToken = this.getCookie('cookie_consent_user_consent_token') || '';
    console.log("cookieConsentToken", cookieConsentToken);
    return cookieConsentToken;
  }

  isSpecificPage() {
    const specificPagePath = '/'; // Replace with your specific page path
    return window.location.pathname === specificPagePath;
  }

  initCookieConsent() {
    cookieconsent.run({
      "notice_banner_type": "interstitial",
      "consent_type": "express",
      "palette": "light",
      "language": "fr",
      "page_load_consent_levels": ["strictly-necessary"],
      "notice_banner_reject_button_hide": false,
      "preferences_center_close_button_hide": false,
      "page_refresh_confirmation_buttons":  this.isSpecificPage(),
    });
  }

  resetCookies() {
    document.cookie = 'cookie_consent_user_consent_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    document.cookie = 'cookie_consent_level=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    document.cookie = 'cookie_consent_user_accepted=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
    console.log('Cookies have been reset');
    this.initCookieConsent(); // Reinitialize the cookie consent
  }

  async getTrackingConsent(): Promise<boolean> {
    const trackingConsent = this.getCookie('cookie_consent_level');

    if(!this.getCookieConsentToken()) {
      this.initCookieConsent();
    }

    console.log("trackingConsent", trackingConsent);
    // Décoder la valeur du cookie
    const decodedConsent = decodeURIComponent(trackingConsent);
    // Convertir la chaîne décodée en objet JavaScript
    const consentObject = JSON.parse(decodedConsent);
    // Récupérer la valeur de tracking
    const tracking = consentObject['tracking'];
    console.log("trackingConsent tracking", tracking); // false
    return tracking;
  }

  trackingConsent(trackingConsent: boolean) {
    this.apiService.trackingConsent(trackingConsent).subscribe((resp: any) => {
      console.log("trackingConsent resp => ", resp);
    }, (error) => {
      console.error("trackingConsent error => ", error);
    });
  }

  hasConsent(): boolean {
    return !!this.getCookieConsentToken();
  }
}
